export default __webpack_public_path__ + "static/media/Igel.c2cf51fe.png";